/**
 * Centralized Breakpoints System
 *
 * Based on Bootstrap 3 responsive breakpoints from bootstrap-variables.less
 */

export const breakpoints = {
  values: {
    xs: 0,         // Extra small (mobile)
    sm: 768,       // Small screen / tablet (@screen-sm)
    md: 992,       // Medium screen / desktop (@screen-md)
    lg: 1200,      // Large screen / wide desktop (@screen-lg)
    xl: 1920,      // Extra large (modern addition)
  },

  // Bootstrap 3 breakpoint names for reference
  bootstrap: {
    phone: 480,         // @screen-xs
    tablet: 768,        // @screen-sm
    desktop: 992,       // @screen-md
    wideDesktop: 1200,  // @screen-lg
  },

  // Container max widths (from Bootstrap 3 @container-* variables)
  containerMaxWidth: {
    sm: 750,    // @container-tablet (720px + 30px gutter)
    md: 970,    // @container-desktop (940px + 30px gutter)
    lg: 1170,   // @container-large-desktop (1140px + 30px gutter)
  },

  // Grid float breakpoint (navbar collapse point)
  gridFloatBreakpoint: 768, // @grid-float-breakpoint
} as const;

export type Breakpoints = typeof breakpoints;
